import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import Vue from 'vue';
import store from '../store.js';

var translateFilter = function translateFilter(value) {
  if (!value) return false;
  var oldLan;
  var newLan = store.state.language;

  if (newLan == 'cn') {
    oldLan = 'en';
  } else if (newLan == 'en') {
    oldLan = 'cn';
  }

  var transitionList = store.state.transitionList;

  try {
    return transitionList.filter(function (item) {
      return item[oldLan] == value;
    })[0][newLan];
  } catch (_unused) {
    // console.log('catch')
    return value;
  }
};

var filterImg = function filterImg(url) {
  if (url) {
    if (url.indexOf('http') == 0 || url.indexOf('https') == 0) {
      return url;
    } else {
      return require('../../public/static/image/nocover.png');
    }
  } else {
    return require('../../public/static/image/nocover.png');
  }
};

var filterName = function filterName(name) {
  if (name) {
    var userName = store.state.userInfo.UserName;

    if (name != userName) {
      var res = formatName(name);
      return res;
    } else {
      return name;
    }
  }
};

export { translateFilter, filterImg, filterName };

var formatName = function formatName(name) {
  var newStr;

  if (name.length === 2) {
    newStr = name.substr(0, 1) + '*';
  } else if (name.length > 2) {
    var char = '';

    for (var i = 0, len = name.length - 2; i < len; i++) {
      char += '*';
    }

    newStr = name.substr(0, 1) + char + name.substr(-1, 1);
  } else {
    newStr = name;
  }

  return newStr;
};